var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Layout', [_vm.loading || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('GrayHeader', [_c('MottoBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Network Connect',
        routeName: 'network-connect'
      }, {
        label: _vm.isResendPage ? 'Resend Referral' : "Create Referral"
      }],
      "back-route": 'network-connect'
    }
  }), _c('BaseTitle', {
    staticClass: "gray-header-title"
  }, [_vm._v(_vm._s(_vm.isResendPage ? 'Resend Referral' : "Create Referral"))])], 1), _c('p', {
    staticClass: "mt-3 color-secondary-light-blue",
    class: _vm.$style.borrowerText
  }, [_vm._v(" Borrower information will NEVER be shared and is only displayed for you to organize your deal-level referrals. Either Borrower First or Last Name is required. ")]), _c('ValidationObserver', {
    ref: "validationObserver",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Borrower First Name",
            "edit-mode": !_vm.reviewMode && !_vm.isResendPage,
            "value": _vm.borrowerFirstName,
            "placeholder": "Borrower First Name"
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.borrowerFirstName = $event;
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Borrower Last Name",
            "edit-mode": !_vm.reviewMode && !_vm.isResendPage,
            "value": _vm.borrowerLastName,
            "placeholder": "Borrower Last Name"
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.borrowerLastName = $event;
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Subject Property Address State",
            "edit-mode": !_vm.reviewMode && !_vm.isResendPage,
            "value": _vm.state,
            "rules": 'required',
            "edit-select-values": _vm.states,
            "placeholder": "Select..."
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.state = $event;
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Loan Type",
            "edit-mode": !_vm.reviewMode && !_vm.isResendPage,
            "value": _vm.loanType,
            "edit-select-values": _vm.loanTypeOptions,
            "rules": 'required',
            "placeholder": "Select..."
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.loanType = $event;
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Loan Amount",
            "edit-mode": !_vm.reviewMode && !_vm.isResendPage,
            "value": _vm.loanAmount,
            "edit-select-values": _vm.loanAmountOptions,
            "placeholder": "Select..."
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.loanAmount = $event;
            }
          }
        }), _c('div')], 1), _c('p', {
          staticClass: "p1 mt-10 mb-10 color-dark-gray"
        }, [_vm._v(_vm._s(_vm.recipientsLabel) + ":")]), !_vm.reviewMode ? _c('div', {
          class: _vm.$style.radioButtonsContainer
        }, [_c('BaseRadioButton', {
          attrs: {
            "label": "Offices",
            "name": "referralTypeButton",
            "value": "Offices"
          },
          model: {
            value: _vm.referralType,
            callback: function callback($$v) {
              _vm.referralType = $$v;
            },
            expression: "referralType"
          }
        }), _c('BaseRadioButton', {
          attrs: {
            "label": "MLOs",
            "name": "referralTypeButton",
            "value": "Users"
          },
          model: {
            value: _vm.referralType,
            callback: function callback($$v) {
              _vm.referralType = $$v;
            },
            expression: "referralType"
          }
        })], 1) : _vm._e(), _vm.searchBy && !_vm.reviewMode ? _c('div', {
          class: _vm.$style.searchContainer
        }, [_c('div', {
          class: _vm.$style.searchInputContainer
        }, [_c('div', {
          staticClass: "d-flex position-relative"
        }, [_c('BaseInputText', {
          class: _vm.$style.searchQuery,
          attrs: {
            "disabled": !_vm.state || _vm.selectAllUsers[0],
            "name": "searchQuery",
            "placeholder": _vm.searchLabel
          },
          on: {
            "input": function input() {
              _vm.searchingRecipients = true;
              _vm.searchRecipientsBySearchQuery();
            }
          },
          model: {
            value: _vm.searchQuery,
            callback: function callback($$v) {
              _vm.searchQuery = $$v;
            },
            expression: "searchQuery"
          }
        }), _c('MottoIcon', {
          class: _vm.$style.searchIcon,
          attrs: {
            "name": "Search"
          }
        })], 1), _vm.state && _vm.referralType === 'Users' ? _c('BaseCheckbox', {
          attrs: {
            "label": "Select All (State Wide)",
            "input-value": '1'
          },
          model: {
            value: _vm.selectAllUsers,
            callback: function callback($$v) {
              _vm.selectAllUsers = $$v;
            },
            expression: "selectAllUsers"
          }
        }) : _vm._e()], 1), _c('div', {
          class: _vm.$style.searchResultsContainer,
          on: {
            "scroll": _vm.checkScrollForSearchContainer
          }
        }, [!_vm.state ? _c('p', {
          staticClass: "text-center my-3"
        }, [_vm._v("Select a state to display recipients")]) : _vm._e(), _vm.searchRecipients.length && _vm.searchQuery && !_vm.searchingRecipients ? _vm._l(_vm.searchRecipients, function (recipient) {
          return _c('SearchRecipientResult', {
            key: recipient.id,
            attrs: {
              "recipient": recipient,
              "disabled": _vm.shouldDisableRecipient(recipient),
              "selected": _vm.selectedRecipientIds.includes(recipient.id)
            },
            on: {
              "select-recipient": _vm.selectRecipient
            }
          });
        }) : _vm.recipients.length && !_vm.searchQuery ? _vm._l(_vm.recipients, function (recipient) {
          return _c('SearchRecipientResult', {
            key: recipient.id,
            attrs: {
              "disabled": _vm.shouldDisableRecipient(recipient),
              "recipient": recipient,
              "selected": _vm.selectedRecipientIds.includes(recipient.id) || !!_vm.selectAllUsers[0]
            },
            on: {
              "select-recipient": _vm.selectRecipient
            }
          });
        }) : _vm._e(), _vm.loadedRandomizedRecipientPages !== 0 && _vm.recipients.length === 0 && !_vm.searchQuery && !_vm.searchingRecipients ? _c('p', {
          staticClass: "text-center my-3"
        }, [_vm._v(" No recipients found ")]) : _vm._e(), !_vm.searchingRecipients && _vm.searchQuery && _vm.searchRecipients.length === 0 ? _c('p', {
          staticClass: "text-center my-3"
        }, [_vm._v(" No recipients found ")]) : _vm._e(), _vm.searchingRecipients ? _c('LoaderIcon', {
          staticClass: "my-3"
        }) : _vm._e(), _vm.referralType && _vm.state && !_vm.isLastPageLoaded && !_vm.searchQuery ? _c('LoaderIcon', {
          staticClass: "my-3"
        }) : _vm._e()], 2)]) : _vm._e(), _vm.isStatewide && _vm.reviewMode ? _c('h4', {
          staticClass: "font-weight-bold color-primary-blue"
        }, [_vm._v("State-wide")]) : _vm._e(), !_vm.isStatewide ? _c('div', {
          class: _vm.$style.selectedRecipientsTags
        }, _vm._l(_vm.selectedRecipientIds, function (recipientId) {
          return _c('TagSelector', {
            key: recipientId,
            attrs: {
              "removable": !_vm.reviewMode
            },
            on: {
              "remove": function remove() {
                _vm.selectRecipient({
                  recipientId: recipientId
                });
              }
            }
          }, [_vm._v(" " + _vm._s(_vm.getRecipientById({
            recipientId: recipientId
          }).name || _vm.getRecipientById({
            recipientId: recipientId
          }).tradeName) + " ")]);
        }), 1) : _vm._e(), _vm.reviewMode ? _c('InfoBlock', {
          staticClass: "mt-5",
          class: _vm.$style.respaWarning,
          attrs: {
            "theme": "warning",
            "hide-icon": ""
          }
        }, [_vm._v(" Disclaimer: Nothing of value can be received or given for this referral per Respa section 8 ")]) : _vm._e(), !_vm.reviewMode ? _c('div', {
          class: _vm.$style.bottomButtonsContainer
        }, [_c('BaseButton', {
          attrs: {
            "options": {
              defaultPadding: true
            },
            "theme": "white"
          },
          on: {
            "click": _vm.confirmExit
          }
        }, [_vm._v("Cancel")]), _c('BaseButton', {
          attrs: {
            "options": {
              defaultPadding: true
            },
            "disabled": !_vm.referralType
          },
          on: {
            "click": function click($event) {
              return handleSubmit(_vm.enterReviewMode);
            }
          }
        }, [_vm._v(" Review ")])], 1) : _vm._e(), _vm.reviewMode ? _c('div', {
          class: _vm.$style.bottomButtonsContainer
        }, [_c('BaseButton', {
          attrs: {
            "options": {
              defaultPadding: true
            },
            "theme": "white"
          },
          on: {
            "click": function click($event) {
              _vm.reviewMode = false;
            }
          }
        }, [_vm._v("Edit")]), _c('BaseButton', {
          attrs: {
            "options": {
              defaultPadding: true
            },
            "disabled": !_vm.referralType
          },
          on: {
            "click": _vm.submitForm
          }
        }, [_vm.submitting ? [_c('BaseIcon', {
          attrs: {
            "name": "spinner",
            "spin": ""
          }
        })] : [_vm._v("Submit")]], 2)], 1) : _vm._e()];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }